import lazyLoading from './lazyLoading';

export default {
  name: 'Notifications',
  meta: {
    expanded: false,
    title: 'schema.notifications',
    iconClass: 'far fa-bell',
  },
  children: [
    {
      name: 'Notification',
      path: '/notification/notifications/:id?',
      component: lazyLoading('notification/Notifications'),
      meta: {
        title: 'menu.myNotifications',
        iconClass: 'far fa-bell',
        to: '/notification/notifications',
        auth: true
      },
      props: r => ({root: true, id: r.params.id}),
    },
    {
      name: 'Send Notification',
      path: '/notification/send',
      component: lazyLoading('notification/Send'),
      meta: {
        title: 'menu.sendNotification',
        iconClass: 'fa fa-paper-plane',
        to: '/notification/send',
        auth: 'admin',
      },
      props: r => ({root: true}),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/notifications.js